import React, { useState } from 'react'

import {
  Box,
  FormControl,
  InputLabel,
  Select,
  TableContainer,
} from '@mui/material'
import { listFromCodes } from '../../../Functions/ListItemGenerator'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { useHoldingContext } from '../../../Contexts/CurrentHolding'

import { useUserContext } from '../../../Contexts/UserConfig'
import { oldLinesReportCols } from './OldLinesReportCols'
import { useGetOldLinesReport } from '../../../APIs/Hooks/ReportServiceHooks'
import PageSection from '../../../Constants&Theme/PageSection'
import { appBar } from '../../../garvan-react/Constants/StyleConstants'
import { reportDGProps } from '../ReportProps'

function OldLinesReport() {
  const { currentHolding } = useHoldingContext()
  const { loginConfig, loadingConfig } = useUserContext()
  const [holdingID, setHoldingID] = useState(currentHolding.value)
  const reportQuery = useGetOldLinesReport(holdingID)
  const holdings = listFromCodes(
    loginConfig,
    'KV-Holdings',
    loadingConfig,
    currentHolding.value,
  )

  return (
    <Box
      sx={{
        maxWidth: 'xl',
        width: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <PageSection title={'Lines Not Recently Used Report'}>
        <FormControl
          fullWidth
          sx={{ mb: 2 }}
        >
          <InputLabel>Select Holding</InputLabel>
          <Select
            inputProps={{ 'aria-label': 'SelectHolding' }}
            label="Select Holding"
            value={holdingID}
            onChange={(e) => setHoldingID(e.target.value as number)}
          >
            {holdings}
          </Select>
        </FormControl>
        <TableContainer
          sx={{ height: `calc(100vh - ${appBar}px - 300px)`, width: 1 }}
        >
          <DataGridPro
            {...reportDGProps}
            getRowId={(row) => row.ShortLineName}
            rows={reportQuery.data ?? []}
            columns={oldLinesReportCols}
            loading={reportQuery.isFetching}
          />
        </TableContainer>
      </PageSection>
    </Box>
  )
}

export default OldLinesReport
